import React, { useEffect, useState } from 'react'
import { RootState } from '../../../global/config/store';
import { useSelector } from 'react-redux';
import { Autocomplete, Box, FormControl, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { ApiGetClientEntityByClientGroupId, ApiGetVenueList, ApiGetShopperList, ApiGetCompleteAllocation } from '../../../apiService/Core/Apicall.tsx';
import useDebounce from '../CreateAllocations/UseDebounce.tsx';
import { toast } from 'react-toastify';

interface CompleteAllocationRow {
    venueId: {
        venueName: string;
        venueCode?: string;
        address?: string;
        postalCode?: string;
        tradingHours?: string;
        websiteURL?: string;
        shopTypeId: {
            shopTypeName?: string;
        };
    };
    userId: {
        firstName: string;
        lastName: string;
    };
    checkInLat: number;
    checkInLong: number;
    checkOutLat: number;
    checkOutLong: number;
    checkInDateTime?: string;
    checkOutDateTime?: string;
    createdOn: string;
    visitTimeInformation?: string;
    checkInImage?: string;
    checkOutImage?: string;
}
function CompleteAllocation() {

    const [currentDate, setCurrentDate] = useState(new Date())
    const [venueName, setVenueName] = useState([])
    const [venueNameValue, setVenueNameValue] = useState<any>(null)
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<string | null>(null)
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(null)
    const [ClientId, setClientId] = useState(null)
    const [venus, setVenus] = useState([])
    const debouncedClientEntityId = useDebounce(clientEntityId, 500)
    const [shopper, setShopper] = useState([])
    const [shopperlist, setshopperlist] = useState([])
    // const [selectedShopper, setselectedShopper] = useState<any>(null)
    const [details, setDetails] = useState<CompleteAllocationRow[]>([])
    const [selectedShopper, setSelectedShopper] = useState<any>()
    const [searchShopper, setsearchShopper] = useState<any>([])

    useEffect(() => {
        if (Clientlist.length > 2) {
            setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);

    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            return newDate
        })
    }

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            const jobMonth = newDate.getMonth() + 1
            const jobYear = newDate.getFullYear()
            return newDate
        })
    }

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        setCurrentDate(newDate)
    }

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }
    useEffect(() => {
        if (clientEntityId === null) {
            setVenueName([])
        }
    }, [clientEntityId])


    useEffect(() => {
        console.log("ClientId", ClientId)
        handleGetClientList()
    }, [ClientId])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${ClientId}`
        if (!ClientId) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            console.log(res.data)
            setClientEntityList(res.data)
            // setClientEntityId(res.data[0].clientEntityId)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        const data = `?clientEntityId=${clientEntityId}&offset=0&limit=500`
        const res = await ApiGetVenueList(data)
        setVenus(res?.data)
        const response = res?.data.map((item) => ({
            label: item.venueName,
            value: item.venueId,
        }))
        setVenueName(response)
        // setVenueNameValue(response[0]?.value);
    }
    useEffect(() => {
        if (debouncedClientEntityId) {
            ApiCallGetVenueList(debouncedClientEntityId)
        } else {
            setVenueName([])
            setVenueNameValue(null)
        }
    }, [debouncedClientEntityId])
    const getShopperList = async (text) => {
        setshopperlist([])
        try {
            const data = `?offset=0&limit=20${text?.length > 0 ? `&search=${text}` : ''}`
            const res = await ApiGetShopperList(data)
            const originonal = res.data
            console.log("Live Data", originonal)
            setshopperlist(originonal)
            const defaultselected = (res.data?.filter(item => item.firstName !== ''))
            // setSelectedShopper(defaultselected[0])

        } catch (error) {
            alert(error)
        }
    }
    useEffect(() => {
        getShopperList(searchShopper);
    }, [searchShopper])
    const jobMonth = currentDate.getMonth() + 1;
    const jobYear = currentDate.getFullYear();

    const ApiCallGetCompletedAllocation = async (jobMonth: number, jobYear: number) => {
        let data = `?jobMonth=${jobMonth}&jobYear=${jobYear}`;
        if (venueNameValue) data += `&venueId=${venueNameValue}`;
        if (selectedShopper) data += `&userId=${selectedShopper?.userId}`;

        try {
            const res = await ApiGetCompleteAllocation(data);
            setDetails(res?.data || []);
            console.log("API response for completed allocation:", res?.data);

        } catch (error) {
            console.error("Error fetching allocations:", error);
            toast.error("Failed to load allocations");
        }
    };
     console.log('Shopt Type', details);
     
    useEffect(() => {
        ApiCallGetCompletedAllocation(
            currentDate.getMonth() + 1,
            currentDate.getFullYear()
        );
    }, [currentDate, venueNameValue, selectedShopper]);

    return (
        <Box sx={{ p: 4 }} style={{ background: "white" }}>
            <Stack spacing={3}>
                <Box sx={{ width: "100%" }}>
                    <h1 className="common-manage-h1 mt-0 col-6" style={{ textAlign: "end", marginLeft: "250px" }}>
                        Allocation Completed
                    </h1>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: 'center',
                            gap: 2,
                            marginTop: "23px",
                        }}
                    >
                        <Stack direction="row" spacing={2}>
                            <FormControl size="small" sx={{ width: 180 }}>
                                <Autocomplete
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={Clientlist}
                                    value={selectedClient}
                                    getOptionLabel={(option: any) => option?.clientGroupName}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.clientGroupDBName === value.clientGroupDBName
                                    }
                                    onChange={(event, newValue: any) => {
                                        setSelectedClient(newValue)
                                        setClientId(newValue?.clientGroupName || null)
                                        if (!newValue || (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)) {
                                            setClientEntityId(null)
                                            setVenueNameValue(null)
                                            setClientEntityList([])
                                        }
                                    }}
                                    defaultValue="mmcommon"
                                    renderInput={(params) => <TextField {...params} label="Select Client" />}
                                    size="small"
                                />
                            </FormControl>
                        </Stack>
                        <Stack direction="row" spacing={2}>
                            <FormControl size="small" sx={{ width: 180 }}>
                                <Autocomplete
                                    disablePortal
                                    id="beacon-autocomplete"
                                    options={clientEntityList?.filter((item) => item.clientEntityId !== null)}
                                    getOptionLabel={(option) => option?.entityName || ""}
                                    onChange={(event, newValue: any) => {
                                        setClientEntityId(newValue?.clientEntityId || null)
                                        if (!newValue) {
                                            setVenueNameValue(null)
                                        }
                                    }}
                                    value={clientEntityList?.find((option) => option?.clientEntityId === clientEntityId) || null}
                                    renderInput={(params) => <TextField {...params} label="Select Business" />}
                                    size="small"
                                />
                            </FormControl>
                            <FormControl size="small" sx={{ width: 180 }}>
                                <Autocomplete
                                    disablePortal
                                    id="mm-autocomplete"
                                    options={venueName}
                                    value={venueName.find((option: any) => option.value === venueNameValue) || null}
                                    onChange={(event, newValue: any) => {
                                        setVenueNameValue(newValue?.value)
                                    }}
                                    defaultValue=""
                                    renderInput={(params) => <TextField {...params} label="Select Venue" />}
                                    size="small"
                                />
                            </FormControl>
                        </Stack>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginLeft: "330px"
                            }}
                        >
                            <IconButton onClick={handlePrevMonth}>
                                <ChevronLeftIcon />
                            </IconButton>
                            <Box sx={{ display: "flex", alignItems: "center", mx: 0 }}>
                                <input
                                    type="month"
                                    value={formatDate(currentDate)}
                                    onChange={handleDateChange}
                                    className="primary-color"
                                    style={{
                                        border: "none",
                                        background: "none",
                                        fontSize: "1.25rem",
                                        fontWeight: "bold",
                                        cursor: "pointer",
                                        fontFamily: "inherit",
                                    }}
                                />
                            </Box>
                            <IconButton onClick={handleNextMonth}>
                                <ChevronRightIcon />
                            </IconButton>
                        </Box>
                        <Box className='d-flex justify-content-end' flexGrow={1}>
                            <FormControl size="small" className='col-3'>
                                <Autocomplete
                                    id='serach_shopper'
                                    disablePortal
                                    options={shopperlist?.filter((item: any) => item?.firstName !== '')}
                                    value={selectedShopper}
                                    onInputChange={(event, newInputValue) => { setsearchShopper(newInputValue) }}
                                    getOptionLabel={(option: any) => `${option?.firstName} ${option.lastName}`}
                                    isOptionEqualToValue={(option: any, value: any) =>
                                        option.userId === value.userId || option.emailId === value.emailId
                                    }
                                    filterOptions={(options, { inputValue }) =>
                                        options.filter((option) => {
                                            const fullName = `${option.firstName} ${option.lastName}`.toLowerCase();
                                            const email = option.emailId?.toLowerCase() || '';
                                            const search = inputValue.toLowerCase();
                                            return fullName.includes(search) || email.includes(search);
                                        })
                                    }
                                    onChange={(event, newValue: any) => {
                                        setSelectedShopper(newValue)
                                    }}
                                    // defaultValue={shopperlist?.filter(item => item.firstName !== '')[0]}
                                    renderInput={(params) => <TextField {...params} label="Select Shopper" />} size="small"
                                />
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            </Stack>
            <Box sx={{ width: '100%', marginTop: 5 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#757b52' }}>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Venue</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Visit Details</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Check In</TableCell>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Check Out</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {details.length > 0 ? details?.map((row, index) => (
                            <TableRow key={index} sx={{ verticalAlign: 'top' }}>
                                <TableCell>
                                    <Typography fontWeight="bold">{row?.venueId?.venueName}</Typography>
                                    <Typography variant="body2">({row?.venueId?.shopTypeId?.shopTypeName|| 'N/A'})</Typography>
                                    <Box mt={5}>
                                        <Typography>
                                            <b>Address:</b> {row?.venueId?.address}
                                        </Typography>
                                        <Typography>
                                            <b>PostCode:</b> {row?.venueId?.postalCode}
                                        </Typography>
                                        <Typography>
                                            <b>Trade hours:</b> {row.venueId?.tradingHours}
                                        </Typography>
                                        <Typography>
                                            <b>Website:</b>{' '}
                                            <a href={row?.venueId?.websiteURL} target="_blank" rel="noopener noreferrer">
                                                {row?.venueId?.websiteURL}
                                            </a>
                                        </Typography>
                                    </Box>
                                </TableCell>

                                <TableCell>
                                    <Box mt={10}>
                                        <Typography>
                                            <b>Allocated Date:</b> <br /> { }
                                        </Typography>
                                        <Typography>
                                            <b>Allocated Time:</b> { }
                                        </Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box mt={10}>
                                        <Typography>
                                            <b>Check In Date:</b> <br /> {row.checkInDateTime ? new Date(row.checkInDateTime).toLocaleDateString() : 'N/A'}
                                        </Typography>
                                        <Typography>
                                            <b>Check In Time:</b> {row.checkInDateTime ? new Date(row.checkInDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A'}
                                        </Typography>
                                        <Box mt={1}>
                                            {row.checkInLat && row.checkInLong ? (
                                                <a
                                                    href={`https://www.google.com/maps?q=${row.checkInLat},${row.checkInLong}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <iframe
                                                        width="40"
                                                        height="40"
                                                        loading="lazy"
                                                        allowFullScreen
                                                        style={{ border: 0, cursor: "pointer" }}
                                                        src={`https://www.google.com/maps?q=${row.checkInLat},${row.checkInLong}&hl=es;z=14&output=embed`}
                                                    />
                                                </a>
                                            ) : (
                                                <Typography variant="body2" color="text.secondary">
                                                    Location unavailable
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box mt={10}>
                                        <Typography>
                                            <b>Check Out Date:</b><br /> {row.checkOutDateTime ? new Date(row.checkOutDateTime).toLocaleDateString() : 'N/A'}
                                        </Typography>
                                        <Typography>
                                            <b>Check Out Time:</b> {row.checkOutDateTime ? new Date(row.checkOutDateTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'N/A'}

                                        </Typography>
                                        <Box mt={1}>
                                            <Box mt={1}>
                                                {row.checkOutLat && row.checkOutLong ? (
                                                    <a
                                                        href={`https://www.google.com/maps?q=${row.checkOutLat},${row.checkOutLong}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <iframe
                                                            width="40"
                                                            height="40"
                                                            loading="lazy"
                                                            allowFullScreen
                                                            style={{ border: 0, cursor: "pointer" }}
                                                            src={`https://www.google.com/maps?q=${row.checkOutLat},${row.checkOutLong}&hl=es;z=14&output=embed`}
                                                        />
                                                    </a>
                                                ) : (
                                                    <Typography variant="body2" color="text.secondary">
                                                        Location unavailable
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )) : <TableRow><TableCell colSpan={4}>No Data Found</TableCell></TableRow>}
                    </TableBody>
                </Table>
            </Box>
        </Box>
    )
}
export default CompleteAllocation;